import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import "./style.css";
import "@shopify/polaris/dist/styles.css";
import en from "@shopify/polaris/locales/en.json";
import { AppProvider, Button } from "@shopify/polaris";
import { BrowserRouter, Link, Switch, Route } from "react-router-dom";
import DashBoard from "./Component/Dashboard";
import Account from "./Component/Account";
import Appearance from "./Component/Appearance";
import Preview from "./Component/Preview";
import Faqs from "./Component/FAQS";
import Staticts from "./Component/Analytics";
function AdapterLink({ url, ...rest }) {
    return <Link to={url} {...rest} />;
}

function App(props) {
    return (
        <div className="App">
            <AppProvider i18n={en} linkComponent={AdapterLink}>
                <BrowserRouter>
                    <MyRouter />
                </BrowserRouter>
            </AppProvider>
        </div>
    );
}

function MyRouter() {
    return (
        <Switch>
            <Route exact path="/">
                <DashBoard />
            </Route>
            <Route path="/account">
                <Account />
            </Route>
            <Route path="/appearance">
                <Appearance />
            </Route>
            <Route path="/preview">
                <Preview />
            </Route>
            <Route path="/staticts">
                <Staticts />
            </Route>
            <Route path="/faqs">
                <Faqs />
            </Route>
        </Switch>
    );
}

export default App;
